import { render, staticRenderFns } from "./usersecurity.vue?vue&type=template&id=4d115900&scoped=true&"
import script from "./usersecurity.vue?vue&type=script&lang=ts&"
export * from "./usersecurity.vue?vue&type=script&lang=ts&"
import style0 from "./usersecurity.vue?vue&type=style&index=0&id=4d115900&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d115900",
  null
  
)

export default component.exports